// BlogCardsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const BlogCardsSection = () => {
  const blogPosts = [
    {
      date: 'March 10, 2020',
      title: 'A Practical Guide to Studying Abroad: From Research to Admission',
      excerpt: 'Choosing the right country, university, and course can feel overwhelming. This guide breaks down the key steps involved in studying abroad, from initial research and consultations to preparing documents and submitting strong applications.',
      image: 'blog-1.jpg',
      link: '/blog/practical-guide-studying-abroad'
    },
    {
      date: 'July 18, 2017',
      title: 'Working Abroad: How to Prepare for International Job Opportunities',
      excerpt: 'Working abroad requires more than finding an open role. Learn how to prepare for overseas employment, understand employer expectations, get interview ready, and organise the documentation needed to pursue work opportunities abroad with confidence.',
      image: 'blog-2.jpg',
      link: '/blog/working-abroad-preparation'
    },
    {
      date: 'July 24, 2024',
      title: 'Making Informed Decisions About Study and Work Abroad',
      excerpt: 'Studying or working abroad is a major life decision. This article explores important factors to consider before starting your journey, including eligibility, timelines, costs, and how professional guidance can help you avoid common mistakes.',
      image: 'blog-3.jpg',
      link: '/blog/informed-decisions-study-work-abroad'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-3 gap-6">
          {blogPosts.map((post, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Link to={post.link} className="group block">
                <div className="relative h-96 bg-gradient-to-br from-[#202356] to-[#2542D4] overflow-hidden">
                  {/* Placeholder for background image - replace with actual image */}
                  <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${require(`../assets/${post.image}`)})` }}></div>
                  
                  {/* Dark Overlay */}
                  <div className="absolute inset-0 bg-[#202356]/60"></div>
                  
                  {/* Content */}
                  <div className="absolute inset-0 p-8 flex flex-col text-white">
                    <div className="flex items-center gap-2 text-sm font-light mb-6">
                      <Calendar size={18} />
                      <span>{post.date}</span>
                    </div>
                    
                    <h3 className="text-xl font-normal mb-4 leading-tight">
                      {post.title}
                    </h3>
                    
                    <p className="text-sm font-light leading-relaxed opacity-90 mb-auto line-clamp-2">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex justify-end mt-8">
                      <ArrowRight size={40} strokeWidth={1} className="text-white group-hover:translate-x-2 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogCardsSection;
